
export function Contact() {
    
    return (
        <div class="right2">
          <center>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
<h1 class="text-5xl md:text-5xl font-bold mb-6">Contact Information</h1><hr/>

<p><strong><u>Street Addresses</u>:</strong><br/>
24 Harrison Avenue<br/>
Monroe Township, NJ 08831</p>
<p>467 Spotswood-Englishtown Road<br/>
Monroe Township, NJ 08831<br/>
</p>

<p><strong><u>Phone #</u>:</strong><br/>
(732) 251-0900</p>
<p><strong><u>Fax #</u>:</strong><br/>
  (732) 251-2979</p>
<p><strong><u>E-mail Addresses</u>:</strong></p>
<p><u>Commissioners</u>:<br/>
Commissioner Dipierro: <a href="mailto:comm.dipierro@monroefd1nj.com">comm.dipierro@monroefd1nj.com</a><br/>
Commissioner Kane: <a href="mailto:comm.kane@monroefd1nj.com">comm.kane@monroefd1nj.com</a><br/>
Commissioner Grossman: <a href="mailto:comm.grossman@monroefd1nj.com">comm.grossman@monroefd1nj.com</a><br/>
Commissioner Costa: <a href="mailto:comm.costa@monroefd1nj.com">comm.costa@monroefd1nj.com</a><br/>
Commissioner DiLieto: <a href="mailto:comm.dilieto@monroefd1nj.com">comm.dilieto@monroefd1nj.com</a></p>
<p>To e-mail all Commissioners at once, use this address: <a href="mailto:commissioners@mtvfc1.com">commissioners@mtvfc1.com</a></p>
<p><u>Staff</u>:<br/>
Secretary Mercado: <a href="mailto:sec.mercado@monroefd1nj.com">sec.mercado@monroefd1nj.com</a><br/>
Matt Jandernal,Fire Official: <a href="mailto:Matt.Jandernal@monroefd1nj.com">matt.jandernal@monroefd1nj.com</a><br/>
</p>
<p>Attorney: Joseph D. Youssouf: <a href="mailto:jyoussouf@aol.com">jyoussouf@aol.com</a><br/>
  Insurance (Oliver L. E. Soden Agency): <a href="http://www.sodeninsurance.com">http://www.sodeninsurance.com</a><br/>
</p>
</center>
<center>

</center>
</div>
    )
}